import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import ChevronLeftSvg from 'images/v5/icons/chevron-left.svg';
import ChevronRightSvg from 'images/v5/icons/chevron-right.svg';
import Button from 'layout/atoms/Button/Button';
function PageControls({ currentPage, pages, t, onPreviousClick, onNextClick }) {
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' } },
        React.createElement("div", { style: {
                overflow: 'hidden',
                borderRadius: '8px',
                background: 'var(--static-fill-foreground)',
            } },
            React.createElement(Button, { theme: "border", shape: "squared", leftIcon: React.createElement(ChevronLeftSvg, null), onClick: onPreviousClick })),
        currentPage && pages && (React.createElement("div", { style: {
                overflow: 'hidden',
                borderRadius: '8px',
                background: 'var(--static-fill-foreground)',
            } },
            React.createElement(Button, { theme: "border" },
                t('page'),
                " ",
                currentPage,
                "/",
                pages))),
        React.createElement("div", { style: {
                overflow: 'hidden',
                borderRadius: '8px',
                background: 'var(--static-fill-foreground)',
            } },
            React.createElement(Button, { theme: "border", shape: "squared", leftIcon: React.createElement(ChevronRightSvg, null), onClick: onNextClick }))));
}
export default withTranslation()(memo(PageControls));
